module.exports = __webpack_public_path__ + "img/2024-03-08a_3.082127c8.jpg";